<template>
  <div>
    <el-card style="margin-bottom:5px"
             :body-style="{ padding: '10px'}"
             shadow="nerver">
      <!-- ------------------------交通类型------------------------ -->
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane v-for="item,index in tabList"
                     :key="index"
                     :label="item.lable"
                     :name="item.name">
          <!-- 方案列表 -->
          <div v-for="item,index in plan_data"
               :key="index">
            <!-- 基本数据: 点击，返回数据 更新 地图 -->
            <div class="block_plan_item"
                 @click="selectTransitPlan(item,index)">
              <div>
                方案:{{index+1}}
                <el-tag style="float:right"
                        v-for="item,index in item.tags"
                        :key="index"
                        size="mini">
                  <span v-if="item=='LEAST_TRANSFER'">少换乘</span>
                  <span v-if="item=='LEAST_TIME'">时间短</span>
                  <span v-if="item=='LEAST_WALKING'">少步行</span>
                </el-tag>
              </div>
              <p>距离： {{(item.distance/1000).toFixed(1)}} 公里; 时间：{{item.duration_1m}}分钟。</p>
            </div>
            <!-- 详细数据：默认隐藏 -->

            <div v-if="activeDetail === index "
                 ref="htem_list"
                 class="block_plan_item_detail">
              <div v-for="step_item,index in item.steps"
                   :key="index">
                <!-- ----------------------------------------------步行方案------------------------------------------ -->
                <div v-if="step_item.mode == 'WALKING'">
                  <p v-if="step_item.distance!=0">🚶‍♀️ 步行约：
                    <span v-if="step_item.distance>1000">{{(step_item.distance/1000).toFixed(2)}}公里,{{step_item.duration}}分钟</span>
                    <span v-else>{{step_item.distance}}米,{{step_item.duration}}分钟</span>
                  </p>

                </div>
                <!-- ----------------------------------------------公共交通------------------------------------------ -->
                <div v-else-if="step_item.mode == 'TRANSIT'">
                  <!-- 交通工具和路线：地铁 -->
                  <p>——</p>
                  <div v-if="step_item.lines[0].vehicle=='SUBWAY'">
                    <!-- 交通描述: 进站、方向、几号口 -->
                    <p>🚊 搭乘: {{step_item.lines[0].title}}({{step_item.lines[0].destination.title}}方向)</p>
                    <p>📍 进站: {{step_item.lines[0].geton.title}}
                      <span v-if="'exit' in step_item.lines[0].geton"> 【{{step_item.lines[0].geton.exit.title}}入】</span>
                    </p>
                    <!-- 多少站 -->
                    <p style="color:grey"> - {{step_item.lines[0].station_count}}站 {{step_item.lines[0].duration}}分钟</p>

                    <p>📍 出站: {{step_item.lines[0].getoff.title}}
                      <!-- 出站 -->
                      <span v-if="'exit' in step_item.lines[0].getoff">【{{step_item.lines[0].getoff.exit.title}}出】</span>
                    </p>
                    <p>——</p>
                  </div>
                  <!-- 交通工具和路线：火车 -->
                  <div v-if="step_item.lines[0].vehicle=='RAIL'">
                    🚅 搭乘高铁/火车前往：
                    距离约： {{(step_item.lines[0].distance/1000).toFixed(1)}} 公里;
                    耗时约：{{step_item.lines[0].duration}} 分钟
                  </div>
                  <!-- 交通工具和路线：公共汽车 -->
                  <div v-if="step_item.lines[0].vehicle=='BUS'">
                    🚌 搭乘公交：<span v-for="bus,index in step_item.lines"
                          :key="index"> {{bus.title}}</span>
                    ｜ ({{step_item.lines[0].destination.title}}方向)
                    <p>🚏 乘车站：{{step_item.lines[0].geton.title}} 站
                      <span v-if="'exit' in step_item.lines[0].geton"> 【{{step_item.lines[0].geton.exit.title}}入】</span>
                    </p>
                    <p style="color:grey"> - {{step_item.lines[0].station_count}}站 {{step_item.lines[0].duration}}分钟</p>
                    <p>🚏 下车站：{{step_item.lines[0].getoff.title}} 站
                      <span v-if="'exit' in step_item.lines[0].getoff">【{{step_item.lines[0].getoff.exit.title}}出】</span>
                    </p>
                    <p>——</p>
                  </div>
                </div>
                <!-- <p>抵达</p> -->
              </div>
              <el-button style="width:100%;margin-top:10px"
                         size="mini"
                         @click="getInnerHtml(item,index)">选择</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'transit-plan-show',
  data() {
    return {
      plan_data: this.planData,
      activeName: this.tabList[0].name,
      activeDetail: null,
    }
  },
  props: {
    planData: Array,
    tabList: {
      type: Array,
      default: () => {
        return [
          { lable: '推荐', name: 'first' },
          { lable: '少换乘', name: 'second' },
          { lable: '少步行', name: 'third' },
          { lable: '不坐地铁', name: 'forth' },
        ]
      },
    },
  },
  watch: {
    planData(newVal) {
      this.plan_data = newVal
    },
  },
  methods: {
    handleClick() {},
    selectTransitPlan(item, index) {
      console.log('方案：', item)
      if (this.activeDetail == index) {
        this.activeDetail = null
      } else {
        this.activeDetail = index
        let pl_list = this.renewMakeRoutesTraffic(item.steps)
        this.$emit('selectTransitPlan', pl_list)
      }
    },
    // 重新绘制公交路线
    renewMakeRoutesTraffic(plan_steps) {
      // console.log(plan_steps)
      let pl_list = []
      plan_steps.forEach((step_item) => {
        // 根据腾讯提供的数据接口[步行 , 公交 , 步行 , 公交 , 步行(到终点)]
        if (step_item.mode == 'WALKING') {
          // console.log('步行')--------------------------
          let pl = this.dealWithPolyline(step_item.polyline)
          // 构建 pl_list_item
          let pl_wlaking_item = {
            id: this.traffic_id,
            styleId: 'style_walking',
            paths: pl,
          }
          pl_list.push(pl_wlaking_item)
        } else if (step_item.mode == 'TRANSIT') {
          // console.log("公共交通")--------------------------
          step_item.lines.forEach((line_item) => {
            // console.log(line_item)
            if (line_item.vehicle == 'BUS') {
              // console.log('搭乘公共汽车')
              // 搭乘公共汽车
              let pl = this.dealWithPolyline(line_item.polyline)
              let pl_wlaking_item = {
                id: this.traffic_id + line_item.id,
                styleId: 'style_bus',
                paths: pl,
              }
              pl_list.push(pl_wlaking_item)
            } else if (line_item.vehicle == 'SUBWAY') {
              // console.log('搭乘地铁')
              // 搭乘地铁
              let pl = this.dealWithPolyline(line_item.polyline)
              let pl_wlaking_item = {
                id: this.traffic_id + line_item.id,
                styleId: 'style_subway',
                paths: pl,
              }
              pl_list.push(pl_wlaking_item)
            } else if (line_item.vehicle == 'RAIL') {
              // console.log('搭乘火车')
              // 搭乘火车
              let pl = this.dealWithPolyline(line_item.polyline)
              let pl_wlaking_item = {
                id: this.traffic_id + line_item.id,
                styleId: 'style_rail',
                paths: pl,
              }
              pl_list.push(pl_wlaking_item)
            }
          })
        }
      })
      return pl_list
    },
    // 解压 polyline
    dealWithPolyline(polyline) {
      let coors = polyline
      // console.log(coors)
      let pl = []
      //坐标解压（返回的点串坐标，通过前向差分进行压缩）
      // let kr = 1000000
      // 不知道为什么但是去掉了就管用 哈哈哈哈
      // for (let i = 2; i < coors.length; i++) {
      //   coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
      // }
      //将解压后的坐标生成LatLng数组
      for (var i = 0; i < coors.length; i += 2) {
        pl.push(new TMap.LatLng(coors[i], coors[i + 1]))
      }
      return pl
    },
    // 发送方案 和 方案说明
    getInnerHtml(item, index) {
      // console.log(index)
      console.log(item)
      console.log(this.$refs.htem_list)
      // console.log(document.getElementsByClassName('block_plan_item_detail'))
      // console.log(this.$refs.htem_list[index])
      const ser = new XMLSerializer()
      // 跟indxe 无关，4个 dom 分别对应上面的4个标签
      const element = this.$refs.htem_list[0]
      const str = ser.serializeToString(element)

      // 格式化 dom
      let introduce = str
        .replace(/<div.*?>/g, '')
        .replace(/<\/div.*?>/g, '')
        .replace(/<span.*?>/g, '')
        .replace(/<\/span.*?>/g, '')
        .replace(/<\/p.*?>/g, '</p>')
        .replace(/<p.*?>/g, '<p>')
        .replace(/<!----><!---->/g, '')
        .replace(/<button.*\/button>/g, '')
        .replace(/<!---->/g, '')
      console.log(introduce)
      // const reg = /<\/?.+?\/?>/g
      // const reg = /<div.*?>/g
      // const val = str.replace(reg, '')
      // console.log(item)
      // .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
      // .replace(/<[^>]+?>/g, '')
      // .replace(/\s+/g, ' ')
      // .replace(/ /g, ' ')
      // .replace(/>/g, ' ')

      this.$emit('bandTransitPlan', item, introduce)
    },
  },
}
</script>

<style scoped>
.block_plan_item {
  background-color: lightgray;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
}
.block_plan_item_detail {
  margin: 5px;
  padding: 10px;
}
</style>